import React, { useState } from 'react';
import styled from 'styled-components';
import {
  TitleContainer,
  ActionButton,
  SettingsLabel,
  OrganisationCheckbox,
} from './components/AccountDetailsComponents';
import AddEmailContact from './AddEmailContact';

const CommunicationEmail = ({ value, onChange }) => {
  const [isAddingEmail, setIsAddingEmailContact] = useState(false);

  const toggleIsAddingEmailContact = () =>
    setIsAddingEmailContact((prevIsAddingEmailContact) => !prevIsAddingEmailContact);

  const addEmailContactChangeHandler = (email) => (checked) => {
    if (!(checked || window.confirm(`Do you want to delete this email? ${email}`))) return;
    onChange(null);
  };

  const addEmailHandler = (email) => {
    onChange(email);
    toggleIsAddingEmailContact();
  };

  return (
    <>
      <SettingsLabel>
        <TitleContainer>No-Reply Communication Email</TitleContainer>
        {!value && <ActionButton onClick={toggleIsAddingEmailContact}>{isAddingEmail ? 'Cancel' : 'Add'}</ActionButton>}
      </SettingsLabel>
      <Container>
        {isAddingEmail && (
          <AddEmailContact
            placeholder="Add Communication Email"
            onSubmit={addEmailHandler}
            onCancel={toggleIsAddingEmailContact}
          />
        )}
        {value && (
          <OrganisationCheckbox checked key={value} onChange={addEmailContactChangeHandler(value)}>
            {value}
          </OrganisationCheckbox>
        )}
      </Container>
    </>
  );
};

const Container = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;

export default CommunicationEmail;
